/*
 * "What are you down here for?" (sections/dte-picker.liquid), prototype A2.
 * The server prints every word, sorted for this month with every panel open. This script only enhances:
 * - month chips (native radios): choosing a month rewrites the month sentence and each row's line,
 *   and re-sorts the rows (FLIP, transforms only);
 * - the rows become an accordion (button inside the h3; closed panels are hidden="until-found");
 * - a year strip per panel, drawn from the lines' data-* attributes (straight lines only);
 * - product labels lean toward the pointer (fine pointers only).
 * Reduced motion: no slides, no entrance, no lean; every state change stays. No library.
 */
(function () {
  'use strict';

  var DIM = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  var KORDER = { dated: 0, month: 1, range: 2, weekly: 3 };
  var NS = 'http://www.w3.org/2000/svg';

  function day(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function el(name, attrs, parent) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function f(n) { return Math.round(n * 10) / 10; }
  function inRange(m, r) { return r[0] <= r[1] ? m >= r[0] && m <= r[1] : m >= r[0] || m <= r[1]; }
  function dateX(d) { var mi = d.getMonth(); return mi * 30 + (d.getDate() - 0.5) / DIM[mi] * 30; }

  function init(sec) {
    if (sec.dataset.yrReady) return;
    sec.dataset.yrReady = '1';

    var T = {};
    try { T = JSON.parse(sec.getAttribute('data-strings') || '{}'); } catch (err) { return; }
    var MONTHS = T.months || [];
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    var now = new Date();
    now = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var NOW_M = now.getMonth() + 1, NOW_Y = now.getFullYear();
    function yearOf(m) { return m >= NOW_M ? NOW_Y : NOW_Y + 1; }
    function fill(tpl, m) { return String(tpl || '').replace('%m', m); }
    function joinAnd(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' ' + T.and + ' ' + a[a.length - 1]; }

    var list = sec.querySelector('[data-list]');
    var acts = [].slice.call(list.querySelectorAll('.dte-yr__act'));
    if (!acts.length) return;

    /* 1. Events: one per line, read from the attributes the server printed */
    // Collected in editor order, so ties sort the same way as the server's render
    var evs = [];
    acts.slice().sort(function (x, y) { return +x.dataset.rank - +y.dataset.rank; }).forEach(function (a) {
      a._evs = [];
      [].forEach.call(a.querySelectorAll('.dte-yr__ev'), function (li) {
        var d = li.dataset, e = { li: li, act: a, kind: d.kind || 'note', tone: d.tone || 'season', short: d.short || '' };
        e.s = d.start ? day(d.start) : null;
        e.e = d.end ? day(d.end) : (e.s || null);
        e.toDay = d.toDay ? +d.toDay : 0;
        e.m = e.kind === 'month' && d.months ? +d.months : 0;
        e.ranges = d.months && e.kind !== 'month' ? d.months.split(',').map(function (r) { var p = r.split('-'); return [+p[0], +(p[1] || p[0])]; }) : null;
        // A page served from cache may be older than today: past lines drop out here too
        e.gone = !!(e.e && e.e < now);
        if (e.gone) { li.hidden = true; return; }
        a._evs.push(e);
        evs.push(e);
      });
    });

    function inMonth(e, m) {
      if (e.s && e.e && (e.kind === 'dated' || e.kind === 'range')) {
        var y = yearOf(m), a = new Date(y, m - 1, 1), b = new Date(y, m, 0);
        return e.s <= b && e.e >= a;
      }
      if (e.kind === 'month') return e.m === m;
      if (e.kind === 'range') return !!e.ranges && e.ranges.some(function (r) { return inRange(m, r); });
      return e.kind === 'weekly' || e.kind === 'allyear';
    }
    function spans(e) {
      if (e.kind === 'allyear') return [[0, 360]];
      if (e.s && e.e) { var a0 = dateX(e.s), a1 = dateX(e.e); if (a1 < a0) a1 += 360; return [[a0, a1]]; }
      if (!e.ranges) return [];
      return e.ranges.map(function (r) {
        var b0 = (r[0] - 1) * 30, b1 = r[1] * 30;
        if (e.toDay && r[1] === 12) b1 = 330 + e.toDay / 31 * 30;
        if (b1 <= b0) b1 += 360;
        return [b0, b1];
      });
    }
    function onIn(m, pool) {
      return pool.filter(function (e) {
        return e.kind !== 'note' && e.kind !== 'allyear' && e.tone !== 'caution' && inMonth(e, m);
      }).sort(function (x, y) { return (KORDER[x.kind] - KORDER[y.kind]) || ((x.s ? +x.s : 0) - (y.s ? +y.s : 0)); });
    }
    function next(a) {
      var best = null, bd = Infinity;
      a._evs.forEach(function (e) {
        var d = e.kind === 'dated' && e.s ? +e.s : e.kind === 'month' ? +new Date(yearOf(e.m), e.m - 1, 1) : Infinity;
        if (d >= +now && d < bd) { bd = d; best = e; }
      });
      return best;
    }

    /* 2. The labels lean toward the pointer, up to 3 degrees */
    if (fine && !reduce) {
      list.addEventListener('pointermove', function (e) {
        var a = e.target.closest && e.target.closest('.dte-yr__pa');
        if (!a) return;
        var r = a.getBoundingClientRect(), k = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width - 0.5) * 2));
        a.style.setProperty('--lean', (k * 3).toFixed(2) + 'deg');
      });
    }

    /* 3. Rows become disclosure buttons; the h3 stays a heading */
    var openAct = null;
    acts.forEach(function (a) {
      var h = a.querySelector('.dte-yr__h3'), body = a.querySelector('[data-body]');
      if (!h || !body) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dte-yr__btn';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', body.id);
      var t = document.createElement('span');
      t.className = 'dte-yr__t';
      t.textContent = h.textContent.trim();
      var pm = document.createElement('span');
      pm.className = 'dte-yr__pm';
      pm.setAttribute('aria-hidden', 'true');
      btn.appendChild(t);
      btn.appendChild(pm);
      h.textContent = '';
      h.appendChild(btn);
      h.classList.add('has-btn');
      btn.addEventListener('click', function () { toggle(a, !a.classList.contains('is-open'), true); });
      body.addEventListener('beforematch', function () { toggle(a, true, false); });
      if (a.classList.contains('is-open')) {
        btn.setAttribute('aria-expanded', 'true');
        openAct = a;
      } else {
        body.setAttribute('hidden', 'until-found');
      }
    });

    function close(a) {
      a.querySelector('[data-body]').setAttribute('hidden', 'until-found');
      a.classList.remove('is-open', 'is-entering');
      var b = a.querySelector('.dte-yr__btn');
      if (b) b.setAttribute('aria-expanded', 'false');
      if (openAct === a) openAct = null;
    }
    function toggle(a, open, user) {
      var btn = a.querySelector('.dte-yr__btn'), body = a.querySelector('[data-body]');
      if (!btn) return;
      var anchor = btn.getBoundingClientRect().top;
      if (open && openAct && openAct !== a) close(openAct);
      if (open) {
        body.removeAttribute('hidden');
        a.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        openAct = a;
        if (user && !reduce) {
          a.classList.remove('is-entering');
          void a.offsetWidth;
          a.classList.add('is-entering');
          setTimeout(function () { a.classList.remove('is-entering'); }, 800);
        }
        var row = a.querySelector('.dte-yr__prs');
        if (row) row.scrollLeft = 0;
      } else {
        close(a);
      }
      // Keep the row you touched where it was when a row above it closes
      if (user) {
        var moved = btn.getBoundingClientRect().top - anchor;
        if (Math.abs(moved) > 1) window.scrollBy(0, moved);
      }
    }

    /* 4. The year strip in each panel: straight, crisp marks */
    acts.forEach(function (a) {
      var box = a.querySelector('[data-strip]');
      if (!box) return;
      var own = a._evs.filter(function (e) { return e.kind !== 'note'; });
      var svg = el('svg', { viewBox: '0 -2 360 42', 'aria-hidden': 'true', focusable: 'false' });
      for (var mm = 1; mm <= 12; mm++) el('rect', { 'class': 's-cell', 'data-cell': mm, x: (mm - 1) * 30, y: -2, width: 30, height: 42 }, svg);
      for (var j = 1; j < 12; j++) el('line', { 'class': 's-rule', x1: j * 30, y1: 0, x2: j * 30, y2: 40 }, svg);
      el('line', { 'class': 's-base', x1: 0, y1: 40, x2: 360, y2: 40 }, svg);
      var lane = 0;
      own.forEach(function (e) {
        if ((e.kind === 'dated' && e.s) || e.kind === 'month') {
          var x = e.kind === 'dated' ? dateX(e.s) : (e.m - 1) * 30 + 15;
          el('path', { 'class': 's-tag' + (e.kind === 'month' ? ' s-tag--tbc' : ''), d: 'M' + f(x - 4) + ' 1H' + f(x + 4) + 'V11L' + f(x) + ' 14L' + f(x - 4) + ' 11Z' }, svg);
        } else if (e.kind === 'weekly') {
          for (var k = 0; k < 52; k++) { var xx = (k + 0.5) * 360 / 52; el('line', { 'class': 's-wk', x1: f(xx), y1: 34, x2: f(xx), y2: 38 }, svg); }
        } else {
          var y = 20 + (lane % 2) * 7;
          lane++;
          spans(e).forEach(function (s) {
            (s[1] > 360 ? [[s[0], 360], [0, s[1] - 360]] : [s]).forEach(function (p) {
              if (e.tone === 'caution') {
                for (var x2 = p[0] + 2; x2 < p[1]; x2 += 4) el('line', { 'class': 's-hatch', x1: f(x2), y1: y - 3, x2: f(x2 + 2), y2: y + 3 }, svg);
              } else if (e.tone === 'market') {
                [y - 2, y + 2].forEach(function (yy) { el('line', { 'class': 's-bar s-bar--market', x1: f(p[0] + 2), y1: yy, x2: f(p[1] - 2), y2: yy }, svg); });
              } else {
                el('line', { 'class': 's-bar', x1: f(p[0] + 3), y1: y, x2: f(p[1] - 3), y2: y }, svg);
              }
            });
          });
        }
      });
      box.appendChild(svg);
      var letters = document.createElement('div');
      letters.className = 'dte-yr__letters';
      (T.monthsShort || []).forEach(function (n, i) {
        var s = document.createElement('span');
        s.setAttribute('data-l', i + 1);
        s.textContent = n.charAt(0);
        letters.appendChild(s);
      });
      box.appendChild(letters);
      box.hidden = false;
    });

    /* 5. Choosing a month rewrites the lines and re-sorts the list */
    var summary = sec.querySelector('[data-summary]');
    var sorted = sec.querySelector('[data-sorted]');
    function settle(m, animate) {
      var on = onIn(m, evs);
      var name = MONTHS[m - 1] + (m === NOW_M ? '' : ' ' + yearOf(m));
      var words = on.filter(function (e) {
        if (e.kind === 'weekly' || e.tone === 'market') return false;
        if (e.kind === 'range' && !(e.s && e.e)) return spans(e).some(function (s) { return s[1] - s[0] <= 150; });
        return !!e.short;
      }).map(function (e) { return e.short; }).filter(function (s, i, arr) { return arr.indexOf(s) === i; });
      if (on.some(function (e) { return e.kind === 'weekly'; })) words.push(T.weekend);
      if (summary) {
        summary.textContent = '';
        var b = document.createElement('b');
        b.textContent = fill(T.onIn, name);
        summary.appendChild(b);
        summary.appendChild(document.createTextNode(' ' + (words.length ? joinAnd(words) + '.' : T.nothing)));
      }
      if (sorted) sorted.textContent = fill(T.comesFirst, MONTHS[m - 1]);

      acts.forEach(function (a) {
        var line = a.querySelector('[data-line]'), mine = onIn(m, a._evs);
        line.textContent = '';
        var lb = document.createElement('b');
        if (mine.length) {
          lb.textContent = fill(T.inMonth, MONTHS[m - 1]);
          line.appendChild(lb);
          line.appendChild(document.createTextNode(' ' + cap(joinAnd(mine.map(function (e) { return e.short; }))) + '.'));
        } else {
          var nx = next(a);
          if (nx) {
            lb.textContent = T.next;
            line.appendChild(lb);
            line.appendChild(document.createTextNode(' ' + cap(nx.short) + '.'));
          } else if (a.dataset.any) {
            line.textContent = a.dataset.any + '.';
          }
        }
        a._score = mine.reduce(function (s, e) { return s + (e.kind === 'dated' ? 100 - e.s.getDate() : e.kind === 'month' ? 30 : 0); }, 0) +
          (mine.some(function (e) { return e.kind === 'range'; }) ? 10 : 0) + (mine.some(function (e) { return e.kind === 'weekly'; }) ? 5 : 0);
        a._evs.forEach(function (e) {
          e.li.classList.toggle('is-now', e.kind !== 'note' && e.kind !== 'allyear' && inMonth(e, m));
        });
        [].forEach.call(a.querySelectorAll('[data-cell]'), function (c) { c.classList.toggle('is-sel', +c.getAttribute('data-cell') === m); });
        [].forEach.call(a.querySelectorAll('[data-l]'), function (c) { c.classList.toggle('is-sel', +c.getAttribute('data-l') === m); });
      });
      reorder(animate);
    }

    // What's on that month first, then editor order. FLIP, transforms only.
    function reorder(animate) {
      var first = acts.map(function (a) { return a.getBoundingClientRect().top; });
      var order = acts.slice().sort(function (x, y) { return (y._score - x._score) || (+x.dataset.rank - +y.dataset.rank); });
      if (order.every(function (a, i) { return list.children[i] === a; })) return;
      var focused = document.activeElement;
      order.forEach(function (a) { list.appendChild(a); });
      if (focused && focused !== document.activeElement && list.contains(focused)) focused.focus({ preventScroll: true });
      if (reduce || !animate) return;
      order.forEach(function (a) {
        var dy = first[acts.indexOf(a)] - a.getBoundingClientRect().top;
        if (!dy) return;
        a.style.transition = 'none';
        a.style.transform = 'translate3d(0,' + dy.toFixed(1) + 'px,0)';
        a.style.zIndex = dy > 0 ? 2 : 1;
      });
      void list.offsetHeight;
      requestAnimationFrame(function () {
        order.forEach(function (a) {
          if (!a.style.transform) return;
          a.style.transition = 'transform 420ms cubic-bezier(0.16, 1, 0.3, 1)';
          a.style.transform = '';
          setTimeout(function () { a.style.transition = ''; a.style.zIndex = ''; }, 460);
        });
      });
    }

    /* Month chips: this month is checked and says "now" in words, not by colour alone */
    var months = sec.querySelector('[data-months]');
    if (months) {
      [].forEach.call(months.querySelectorAll('input[type="radio"]'), function (r) {
        var m = +r.value, t = r.nextElementSibling, old = t && t.querySelector('small');
        if (old) old.remove();
        if (m === NOW_M) {
          r.checked = true;
          var s = document.createElement('small');
          s.textContent = T.now;
          t.appendChild(s);
          r.setAttribute('aria-label', fill(T.thisMonth, MONTHS[m - 1]));
        } else {
          r.setAttribute('aria-label', MONTHS[m - 1] + ' ' + yearOf(m));
        }
      });
      months.hidden = false;
      months.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio') settle(+e.target.value, true);
      });
    }

    /* Start from the visitor's own date (the server's render may be cached). Nothing moves if it matches. */
    settle(NOW_M, false);
    if (!openAct) {
      var top = list.children[0];
      if (top && top._score > 0) toggle(top, true, false);
    }

    // Theme editor: selecting an activity or one of its lines opens it
    sec.addEventListener('shopify:block:select', function (e) {
      var a = e.target && e.target.closest && e.target.closest('.dte-yr__act');
      if (a) toggle(a, true, false);
    });
  }

  function run() { document.querySelectorAll('[data-yr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
